import React from "react";
import cx from "classnames";
import Tooltips from "../Tooltips";
import { useHover } from "../../hooks";
import { FormikCheckbox } from "../Fields/Checkbox";
import ManualEmployerMatchingFields from "./ManualEmployerMatchingFields";
import ManualEmployerMatchingTeaser from "./ManualEmployerMatchingTeaser";
import CheckboxWithTooltip from "../Fields/CheckboxWithTooltip";
import ManualMatchingHelpText from "./ManualMatchingHelpText";

/**
 * @param {object} props
 * @param {object} props.fieldProps
 * @param {boolean} props.hasMatchableDonation
 * @param {boolean} props.isStandardDonationForm
 * @param {boolean} props.isVisible
 * @param {string} props.manualMatchingAmountLabel
 * @param {string} props.manualMatchingCompanyLabel
 * @param {string} props.manualMatchingHelpText
 * @param {string} props.manualMatchingLabel
 * @param {boolean} props.Match_Gift
 * @param {boolean} props.noLeftGutter
 * @param {string} props.teaserLabel
 * @returns {React.JSX.Element}
 */
const ManualEmployerMatching = ({
    fieldProps,
    hasMatchableDonation,
    isStandardDonationForm,
    isVisible,
    manualMatchingAmountLabel,
    manualMatchingCompanyLabel,
    manualMatchingHelpText,
    manualMatchingLabel,
    Match_Gift,
    noLeftGutter = false,
    teaserLabel,
}) => {
    const deviceHasHover = useHover();
    const tooltipMessage =
        "Your gift could be worth more with a matching gift from your employer or participating company!";
    return (
        <div className={cx("col col--12", noLeftGutter && "-padding-left--0")}>
            <div className="-callout -padding--15">
                <div className="qg-vendor-gift-matching gift-matching">
                    {deviceHasHover ? (
                        <div>
                            {hasMatchableDonation ? (
                                <>
                                    <FormikCheckbox
                                        {...fieldProps}
                                        id="Match-Gift"
                                        checked={Match_Gift}
                                        innerPadding={false}
                                    >
                                        {manualMatchingLabel}
                                        <Tooltips
                                            message={tooltipMessage}
                                            placement="bottom"
                                            iconClassName={["-margin-left--10"]}
                                        />
                                    </FormikCheckbox>
                                    {manualMatchingHelpText && (
                                        <ManualMatchingHelpText
                                            manualMatchingHelpText={
                                                manualMatchingHelpText
                                            }
                                        />
                                    )}
                                </>
                            ) : (
                                // Teaser call out displayed on desktop prior to entering a donation amount
                                <ManualEmployerMatchingTeaser
                                    teaserLabel={teaserLabel}
                                />
                            )}
                        </div>
                    ) : (
                        // Mobile display. No Teaser Message used here.
                        <>
                            <CheckboxWithTooltip
                                {...fieldProps}
                                label={manualMatchingLabel}
                                name="Match_Gift"
                                id="Match-Gift"
                                tooltipContent="Your gift could be worth more with a matching gift from your employer or participating company!"
                            />
                            {manualMatchingHelpText && (
                                <ManualMatchingHelpText
                                    manualMatchingHelpText={
                                        manualMatchingHelpText
                                    }
                                />
                            )}
                        </>
                    )}
                    {isVisible && (
                        <ManualEmployerMatchingFields
                            isStandardDonationForm={isStandardDonationForm}
                            manualMatchingCompanyLabel={
                                manualMatchingCompanyLabel
                            }
                            manualMatchingAmountLabel={
                                manualMatchingAmountLabel
                            }
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default ManualEmployerMatching;
